
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BxNotification } from '@/app/interfaces/notification.interface';
import { environment } from '@/app/environments/environment';
@Injectable({
  providedIn: 'root'
})
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private apiUrl = environment.apiUrl;
  public limit = 6;
  constructor(private http: HttpClient) { }

  getRecentNotifications(): Observable<BxNotification[]> {
    return this.http.get<BxNotification[]>(`${this.apiUrl}/user-notifications?limit=${this.limit}`);
  }

  getAllNotifications(): Observable<BxNotification[]> {
    return this.http.get<BxNotification[]>(`${this.apiUrl}/user-notifications`);
  }

  // Approve a specific notification
  approveNotification(notificationId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${notificationId}/approve`, {});
  }


  public sampleNotifications: BxNotification[] = [
    {
      "id": 1,
      "project_id": 1,
      "sender_id": 2,
      "receiver_id": 3,
      "sender_email": "john.doe@example.com",
      "receiver_email": "jane.smith@example.com",
      "stage": 1,
      "subject": "Project Kickoff",
      "event_type": "Project",
      "event_sub_type": "Kickoff",
      "is_obsolete": false,
      "data": {
        "description": "Project kickoff meeting scheduled   Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem veniam, magni dignissimos eligendi iusto temporibus eaque excepturi odit itaque iste velit libero laborum, iure magnam tenetur dolore obcaecati veritatis assumenda harum consequuntur blanditiis officiis sint! Officiis itaque cumque asperiores illo non?.",
        "meeting_date": "2024-11-08",
        "time": "10:00 AM"
      },
      "notification_type": "info",
      "is_read": false,

    },
    {
      "id": 2,
      "project_id": 2,
      "sender_id": 4,
      "receiver_id": 5,
      "sender_email": "alice.brown@example.com",
      "receiver_email": "bob.white@example.com",
      "stage": 2,
      "subject": "Milestone Reached",
      "event_type": "Milestone",
      "event_sub_type": "Phase Completion",
      "is_obsolete": false,
      "data": {
        "milestone": "Phase 1",
        "completion_date": "2024-10-01",
        "description": "Phase 1 has been completed."
      },
      "notification_type": "alert",
      "is_read": false,

    },
    {
      "id": 3,
      "project_id": 3,
      "sender_id": 6,
      "receiver_id": 7,
      "sender_email": "michael.jones@example.com",
      "receiver_email": "carol.taylor@example.com",
      "stage": 3,
      "subject": "Project Update",
      "event_type": "Status",
      "event_sub_type": "Weekly Update",
      "is_obsolete": false,
      "data": {
        "status": "On Track",
        "update_date": "2024-11-05",
        "description": "Project is progressing as planned."
      },
      "notification_type": "info",
      "is_read": false,

    },
    {
      "id": 3,
      "project_id": 3,
      "sender_id": 4,
      "receiver_id": 5,
      "sender_email": "alice.brown@example.com",
      "receiver_email": "bob.white@example.com",
      "stage": 2,
      "subject": "Milestone Reached",
      "event_type": "Milestone",
      "event_sub_type": "Phase Completion",
      "is_obsolete": false,
      "data": {
        "milestone": "Phase 1",
        "completion_date": "2024-10-01",
        "description": "Phase 1 has been completed."
      },
      "notification_type": "alert",
      "is_read": false,

    },
  ];

}
